import { render, staticRenderFns } from "./closed.vue?vue&type=template&id=76a38cdb&scoped=true"
import script from "./closed.vue?vue&type=script&lang=js"
export * from "./closed.vue?vue&type=script&lang=js"
import style0 from "./closed.vue?vue&type=style&index=0&id=76a38cdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a38cdb",
  null
  
)

export default component.exports